export interface IOrganization {
	CodigoOrganizacao: number;
    OrganizacaoNome: string;
    OrganizacaoSigla: string;
    Dhini: string;
    Dhfim: string;
}


export interface IListagemOrganization {
    CodigoOrganizacao: number;
    OrganizacaoNome: string;
    OrganizacaoSigla: string;
    ROW_NUM: number;
    UsuNome: string;         
    Acao: string;
    DhUsuario: Date;
    Dhini: string;
    Dhfim: string;

}

export interface IListagemLogs {
    CodigoOrganizacao: number;       
    UsuNome: string;   
    UsuId:number;
    Acao: string;
    DhUsuario: Date;
    Dhini: string;
    Dhfim: string;
    OrganizacaoNome: string;
    SgOrg:string
   
}


export interface IResponseLogOrg {
    count: number;
    rows: IListagemLogs[];
}
export interface IResponseOrganization {
    count: number;
    rows: IListagemOrganization[];
}

export interface ICreateOrganization {
    CodigoOrganizacao?: number;
    OrganizacaoNome?: string;
    OrganizacaoSigla?: string;
}

export const InicitalCreateOrganization = {
  CodigoOrganizacao: 0,
  OrganizacaoNome: '',
  OrganizacaoSigla: ''
};

